import React from "react";
import Highlight, { defaultProps } from "prism-react-renderer";
import theme from 'prism-react-renderer/themes/github'

const codeBlcokStyles = {
  fontSize: "15px",
  border: "1px solid #e8e8e8",
  borderRadius: "3px",
  backgroundColor: "#eef",
  padding: "8px 12px",
  overflowX: "auto",
}

// https://codetrain.io/adding-prism-syntax-highlighting-to-gatsby-mdx
const CodeBlock = ({ children, className }) => {
  const language = className ? className.replace(/language-/, "") : "";

  return (
    <Highlight
      {...defaultProps}
      code={children}
      language={language}
      theme={theme}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre className={className} style={{ ...style, ...codeBlcokStyles }}>
          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({ line, key: i })}>
              {line.map((token, key) => (
                <span key={key} {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  );
};

export default CodeBlock;